import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';
import ReferenceRequestsAPI from 'api/referenceRequests';

import { Reference } from 'types';
import { hiringRequestQueries } from 'queryKeys/hiringRequest';

export interface ReferenceRequestPayload {
  candidate_id: number;
  is_reminder: boolean;
  message: string;
  recipients: Reference[];
  reference_id: number;
  reference_template_id: number;
  role_title: string;
  subject: string;
}

export interface CreateRequestMutationVariables {
  payload: ReferenceRequestPayload;
}

export const requestReference = (candidateId: number, payload: ReferenceRequestPayload) =>
  ReferenceRequestsAPI.postRequest(candidateId, payload).then((res) => res);

export function useCreateReferenceRequest(
  candidateId: number,
  options?: Omit<
    UseMutationOptions<
      CreateRequestMutationVariables,
      AxiosError,
      ReferenceRequestPayload,
      unknown
    >,
    'mutationFn'
  >
): UseMutationResult<CreateRequestMutationVariables, AxiosError, ReferenceRequestPayload, unknown> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => requestReference(candidateId, payload),
    ...options,
    onSuccess: (data, variables, context) => {
      const queryKey = hiringRequestQueries.hiringRequests.pendingReferences(candidateId).queryKey;

      queryClient.invalidateQueries({
        queryKey,
        refetchType: 'all',
        exact: true,
      });

      options.onSuccess?.(data, variables, context);
    },
  });
}
